<template>
  <div class="dropdown">
    <button :disabled="disabled" class="dropdown-toggle btn-icon clear-area controllers" :id="`dropdownToggle_${guid}`" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
      <icon class="kebab"></icon>
      <span class="sr-only">More Actions Dropdown</span>
    </button>
    <ul class="dropdown-menu" :class="menuClass" :aria-labelledby="`dropdownToggle_${guid}`">
      <slot></slot>
    </ul>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import Guid from "~/helpers/guid";

export default Vue.extend({
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    menuClass: {
      type: String,
      default: '',
    },
  },
  computed: {
    guid(): string {
      return Guid.create();
    },
  },
});
</script>